import { Component, h } from 'preact';

import AnalysisTableRow from './AnalysisTableRow';

import { APTotalVotesToCount } from '../election-utils';

import raceCandidateColors from '../election-candidate-colors';

import appData from 'Data/data.json';
import context from 'Data/text.json';

const countiesData = appData;

type Props = {
  contest: { [key: string]: any };
  candidates: { [key: string]: any };
  counties: { [key: string]: any };
};

class AnalysisTable extends Component<Props> {
  constructor() {
    super();
  }

  render() {
    const { contest, candidates, counties } = this.props;

    if (!contest) return null;

    const countiesData_safe = counties || [];

    // Build candidatesRender: match color definitions to actual candidate IDs from the API
    const colorLookup = [contest.office_slug, '-', contest.party].join('');
    const colorDefs = raceCandidateColors[colorLookup] || [];

    const candidatesRender = colorDefs
      .map(object => {
        const match = contest.candidacies.find(obj => obj.name === object.name);
        return match ? { ...object, id: match.id } : null;
      })
      .filter(Boolean);

    // groupBy: divides counties into categories, sums votes per candidate per category
    function groupBy(arr, criteria) {
      const newObj = arr.reduce(function(acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        const findCounties = countiesData_safe
          .filter(county => county.county == currentValue['county'])
          .map(obj => obj.results)[0];
        const findCounties2 = countiesData_safe
          .filter(county => county.county == currentValue['county'])
          .map(obj => APTotalVotesToCount(obj['eevp'], obj['total_votes']))[0];
        let arrayCounties = {
          ...currentValue,
          ...findCounties,
          estimated_votes: findCounties2,
        };

        acc[currentValue[criteria]].push(arrayCounties);
        return acc;
      }, {});

      const summedEntries = [];

      Object.entries(newObj).forEach(function(val: any) {
        const result = val[1].reduce((r, e, i, a) => {
          const candidateIds = Object.keys(e);
          candidateIds.forEach(k => (r[k] = (r[k] || 0) + parseInt(e[k])));

          if (!a[i + 1])
            Object.keys(e)
              .filter(k => typeof e[k] == 'string')
              .forEach(k => (r[k] /= val[1].length));
          r['category'] = e.category;
          delete r['county'];
          delete r['county_CAPS'];

          return r;
        });

        summedEntries.push(result);
      });
      return summedEntries;
    }

    // createArray: adds total_votes, votes_still_to_count, largest_number per category
    function createArray(arr, criteria) {
      const newObj = arr.reduce(function(acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        acc[currentValue[criteria]].push(currentValue);
        return acc;
      }, []);

      Object.entries(newObj).forEach(function(item: any) {
        function sum(obj) {
          var total = 0;
          var arrayToGetMost = [];
          for (var el in obj) {
            if (el !== 'category' && el !== 'estimated_votes') {
              total += parseFloat(obj[el]);
              arrayToGetMost.push(obj[el]);
            }
          }
          return [total, arrayToGetMost];
        }
        var totals = sum(item[1][0]);
        item[1][0].total_votes = totals[0];
        item[1][0].votes_still_to_count =
          item[1][0].estimated_votes - totals[0];
        totals[1].push(item[1][0].estimated_votes - totals[0]);
        item[1][0].largest_number = Math.max(...totals[1]);
        delete item[1][0].category;
      });
      return newObj;
    }

    const countiesByCategory = groupBy(countiesData.counties, 'category');
    const arrayByCategories = createArray(countiesByCategory, 'category');
    const objectCategories = Object.entries(arrayByCategories);

    let arrayToGetLargest = [];
    objectCategories.forEach((item: any) => {
      arrayToGetLargest.push(item[1][0].largest_number);
    });

    return (
      <span>
        <h3 class="category__title t-sans">{context.categories_headline}</h3>
        <div class="category-grids t-sans">
          {objectCategories &&
            objectCategories.map(categories => (
              <AnalysisTableRow
                contest={contest}
                category={categories[0] as string}
                maxNum={Math.max(...arrayToGetLargest)}
                categoryNumbers={categories}
                candidates={candidates}
                candidatesRender={candidatesRender}
              />
            ))}
        </div>
      </span>
    );
  }
}

export default AnalysisTable;
